module.exports = __webpack_public_path__ + "img/7.462a8d15.jpg";